export const pulseRateIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="17.699" height="16.131" viewBox="0 0 17.699 16.131">
  <g id="HB_Green_Icon" data-name="HB Green Icon" transform="translate(1.032 1.007)">
    <path id="Path_286" data-name="Path 286" d="M74.541,38.991c-2.538-7.388-16.242.414,0,11.221C90.783,39.405,77.08,31.6,74.541,38.991Z" transform="translate(-66.724 -36.089)" fill="none" stroke="#449b27" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
  </g>
</svg>`
